import { PlaceholdersId, TFComponent } from '@types';
import { EstablishmentAssistanceInsurancePlaceholder } from './establishmentAssistanceInsurance';

export const establishmentAssistanceInsurance: TFComponent = {
	component: EstablishmentAssistanceInsurancePlaceholder,
	id: PlaceholdersId.establishmentAssistanceInsurance,
	name: 'establishmentAssistanceInsurance',
};
